import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    matterName: null
  },
  setup(__props: any) {

const props = __props as {
  matterName: string;
}

const { t } = useI18n();


const matterDescription = computed(() => {
  return `${props.matterName.substring(
    0,
    props.matterName.length - ".name".length
  )}.description`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_unref(t)(__props.matterName)), 1),
    _createTextVNode(" " + _toDisplayString(_unref(t)(_unref(matterDescription))), 1)
  ], 64))
}
}

})